import type { ReactNode } from 'react';
import { Animated, StyleSheet } from 'react-native';
import { colors } from '../../theme/colors';
import { motion } from '../../theme/motion';
import { useEntranceAnimation } from '../animations/useAnimations';

interface ScreenTransitionProps {
  children: ReactNode;
}

/**
 * How a screen arrives: content fades in and rises a short distance on the
 * entrance ease. The rise is what separates arriving from popping — a bare
 * opacity fade reads as a flicker, not a transition.
 *
 * Only page content animates. The sidebar and top bar sit outside this
 * boundary and must never re-run their entrance on a route change.
 */
export const SCREEN_ENTRANCE = {
  delay: 0,
  duration: motion.durations.normal,
  translateY: 10,
} as const;

export function ScreenTransition({ children }: Readonly<ScreenTransitionProps>) {
  const { style: animatedStyle } = useEntranceAnimation(SCREEN_ENTRANCE);

  return <Animated.View style={[styles.root, animatedStyle]}>{children}</Animated.View>;
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: colors.background.primary,
  },
});
